// GameActionButton.tsx
import React, { ReactNode, useCallback, useRef } from 'react';
import { motion } from 'framer-motion';

import styles from './GameActionButton.module.css';

export enum GameActionButtonVariant {
  Orange = 'orange',
  Green = 'green',
  Blue = 'blue',
  LogoOrange = 'LogoOrange',
}

interface GameActionButtonProps {
  leading?: ReactNode;
  children: ReactNode;
  trailing?: ReactNode;
  variant?: GameActionButtonVariant;
  debounceTime?: number;
  onClick?: () => void;
}

export const GameActionButton: React.FC<GameActionButtonProps> = ({
  leading = '',
  children,
  trailing = '',
  variant = GameActionButtonVariant.Orange,
  debounceTime = 500,
  onClick,
}) => {
  const lastClickTime = useRef<number>(0);

  const handleClick = useCallback(
    (e: React.MouseEvent) => {
      e.preventDefault();

      const now = Date.now();
      if (now - lastClickTime.current < debounceTime) return;

      lastClickTime.current = now;
      onClick?.();
    },
    [onClick, debounceTime],
  );

  return (
    <motion.button
      whileTap={{ scale: 0.9 }}
      className={styles.button}
      style={{
        backgroundColor:
          variant === GameActionButtonVariant.Orange
            ? '#f07935'
            : variant === GameActionButtonVariant.Green
            ? '#23A79C'
            : variant === GameActionButtonVariant.Blue
            ? '#3292D9'
            : variant === GameActionButtonVariant.LogoOrange
            ? '#EB8C36'
            : '#333',
      }}
      onClick={handleClick}
    >
      <div className={styles.fade} />
      <span className={styles.leading}>{leading}</span>
      <span className={styles.children}>{children}</span>
      <span className={styles.trailing}>{trailing}</span>
    </motion.button>
  );
};
